// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"311":"a8824d06","687":"3e85da79","799":"4a02d170","841":"80eb3fe1","852":"5cf6a9b8","971":"4f034e44"}[chunkId] + ".css";
};